import React, { useEffect } from "react";
import { Col, Container, Row, Card, CardBody } from 'reactstrap';
import ReportOperationsDiary from './components/ReportOperationsDiary';

const OperationsDiary = ({ history, location }) => {
    return (
        <Container className="dashboard">
            <Row>
                <Col md={12}>
                    <div className="title-general-section">
                        <h3>Diario de Operaciones</h3>
                    </div>
                </Col>
            </Row>
            <Card>
                <CardBody>
                    <ReportOperationsDiary />
                </CardBody>
            </Card>
        </Container>
    );
}

export default OperationsDiary;